import React from "react";
import { StarIcon, ClipboardListIcon, FileSearchIcon, MapIcon, FolderCheckIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { CtaButton } from "./CtaButton";
import { testimonials, useCases } from "../data/content";
const useCaseIcons = [ClipboardListIcon, FileSearchIcon, MapIcon, FolderCheckIcon];
export function Testimonials() {
  return <section className="w-full bg-canvas px-5 py-16 sm:py-20" data-id="element-254" data-mp="36yppd1xkx1i9">
      <SectionHeading eyebrow="A Better Diagnostic Process Starts with a Better System" title={<>
            What Other Technicians <span className="text-brand" data-id="element-256" data-mp="2x00552i7n4yu">Use It For</span>
          </>} data-id="element-255" data-mp="370ag0ggrw0au" />

      <div className="mx-auto mt-10 grid max-w-5xl gap-5 md:grid-cols-3" data-id="element-257" data-mp="2s1yospc65jr2">
        {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6" data-id="element-258" data-mp="v9oojjm9rg2g">
            <div className="flex items-center gap-4" data-id="element-259" data-mp="qalko2i0zfw2">
              <img src={t.photo} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-brand-light" data-id="element-260" data-mp="qb50ndo47u7g" />
              <figcaption data-id="element-261" data-mp="m51cjvsy5da0">
                <p className="font-display text-lg font-extrabold leading-tight text-navy" data-id="element-262" data-mp="m5b4hoxjxuic">{t.name}</p>
                <p className="text-sm text-muted" data-id="element-263" data-mp="78k5hgrsikt9">{t.role}</p>
              </figcaption>
            </div>
            <div className="mt-4 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-264" data-mp="c7wpltra1ds5">
              {Array.from({
            length: 5
          }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-265" data-mp="zyixnl1a6y25" data-mpi={i} />)}
            </div>
            <blockquote className="mt-3 text-base leading-relaxed text-navy" data-id="element-266" data-mp="q6wdgz6yton9">“{t.quote}”</blockquote>
          </figure>)}
      </div>

      <ul className="mx-auto mt-10 grid max-w-5xl gap-4 sm:grid-cols-2" data-id="element-267" data-mp="v4eocv4jmdxw">
        {useCases.map((u, i) => {
        const Icon = useCaseIcons[i];
        return <li key={u.title} className="flex gap-4 rounded-2xl border border-navy/10 bg-white p-5" data-id="element-268" data-mp="1nmk1whrffsbr" data-mpi={i}>
              <Icon className="mt-0.5 h-7 w-7 shrink-0 text-brand" aria-hidden="true" data-id="element-269" data-mp="1xiis4va4tii6" />
              <div data-id="element-270" data-mp="1sj5xhod0r751">
                <h3 className="font-display text-base font-extrabold uppercase text-navy" data-id="element-271" data-mp="1sinzam6sqiuh">{u.title}</h3>
                <p className="mt-1 text-base leading-relaxed text-muted" data-id="element-272" data-mp="1og9jyc2c617y">{u.body}</p>
              </div>
            </li>;
      })}
      </ul>

      <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-muted" data-id="element-273" data-mp="1jkke5qzq3o37">
        The examples above describe the intended uses of the product. Individual results depend on the technician, the
        vehicle, the diagnostic problem, and the information available.
      </p>
      <div className="mt-10" data-id="element-274" data-mp="14qz48y2lbg9u">
        <CtaButton data-id="element-275" data-mp="10s9tld8xsctw">I Want a More Structured Workflow</CtaButton>
      </div>
    </section>;
}